import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteItem, fetchData, handleAddItem, handleUpdateItem } from "../../utils/data";
import { Flight } from "../../types";

export const fetchFlights = createAsyncThunk("get/flight", async () => {
    const data = await fetchData(`Flight/getFlights`);
    return data;
});
export const fetchAllFlights = createAsyncThunk("get/allFlight", async () => {
    const data = await fetchData(`Flight/getAllFlights`, true);
    return data;
});
export const addFlight = createAsyncThunk("post/flight", async (flightData: any) => {
    await handleAddItem(flightData, "Flight/addFlight", "POST");
    return flightData;
});
export const updateFlight = createAsyncThunk("PUT/flight", async ({ id, data }: { id: number, data: any }) => {
    await handleUpdateItem(data, `Flight/editFlight?flightId=${id}`, "PUT");
    return { ...data };
});
export const deleteFlight = createAsyncThunk("delete/flight", async (id: number) => {
    await deleteItem(`Flight/deleteFlight?flightId=`, id);
    return id;
});
interface FlightState {
    flights: Flight[];
    allFlights: Flight[];
    flight: Flight | null;
    loading: boolean;
    error: string;
}

const initialState: FlightState = {
    flights: [],
    allFlights: [],
    flight: null,
    loading: false,
    error: ""
};

const flightSlice = createSlice({
    name: "flightSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch
            .addCase(fetchFlights.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchFlights.fulfilled, (state, action) => {
                state.loading = false;
                state.flights = action.payload;
            })
            // Fetch all flights
            .addCase(fetchAllFlights.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchAllFlights.fulfilled, (state, action) => {
                state.loading = false;
                state.allFlights = action.payload;
            })
            // Add
            .addCase(addFlight.fulfilled, (state, action) => {
                state.flights.push(action.payload);
            })

            // Update
            .addCase(updateFlight.fulfilled, (state, action) => {
                state.flights = state.flights.map((item) =>
                    item.id === action.payload.id ? action.payload : item
                );
            })
            // Delete
            .addCase(deleteFlight.fulfilled, (state, action) => {
                state.flights = state.flights.filter((item) => item.id !== action.payload);
            })
    }
});

export default flightSlice.reducer;
